import { all, put, select, takeLatest } from 'redux-saga/effects';
import { getApiParams } from 'api';
import { encode } from 'js-base64';
import { isKzUrl } from 'utils';
import { getHost, getPath, getRegionDomain } from 'selectors';
import { pageModelFetchRequest, pageModelFetchSuccess, pageModelFetchFailed } from './slice';
import { ModelJson } from './types';
import { fetchPageModel } from './api';

export function* pageModelRootSaga() {
	return yield all([takeLatest(pageModelFetchRequest.type, () => getPageModel())]);
}

function formatModelJSON(model) {
	const breadcrumbs = [...model.breadcrumbs];
	breadcrumbs.pop();

	return { ...model, breadcrumbs };
}

export function* getPageModel() {
	try {
		const pathname: string = yield select(getPath);
		const host = yield select(getHost);
		const baseRegion: string = yield select(getRegionDomain);

		//доп логика для Казахстана
		const region = isKzUrl(host) ? 'kazakhstan' : baseRegion;
		const { url, config } = yield getApiParams('/sp/getModel');
		const kzLangUrl = pathname.startsWith('/kz/');

		let modelJson: ModelJson = yield fetchPageModel(
			url,
			{
				pathname: !kzLangUrl ? pathname : pathname.slice(3), //дефиниция принимает только lang поэтому отрезаем кк у пути
				region,
				lang: kzLangUrl ? 'kk' : 'ru',
			},
			config
		);

		const formattedModel = yield formatModelJSON(modelJson); //	для форматирования хлебных крошек

		// Для хардкода типовых
		if (formattedModel?.rules?.rulesText) {
			formattedModel.rules.rulesText = encode(formattedModel.rules.rulesText);
		}

		// Для хардкода дополнительных текстов на SLP
		if (formattedModel?.service?.categoryText) {
			formattedModel.service.categoryText = encode(formattedModel.service.categoryText);
		}

		yield put(pageModelFetchSuccess({ data: formattedModel }));
	} catch (error) {
		yield console.log(error);
		yield put(
			pageModelFetchFailed({ error: { code: error?.status || 500, message: error?.message } })
		);
	}
}
